import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";

export const PhoneCountryField = ({
  language,
  countries,
  selectedCountry,
  phoneNumber,
  onCountryChange,
  onPhoneChange,
}) => {
  const phoneLabel = language === "es" ? "Teléfono" : "Phone number";
  const countryLabel = language === "es" ? "Código de país" : "Country code";
  const helperText = language === "es"
    ? "Usaremos este número para contacto y facturación de tu cuenta."
    : "We will use this number for account contact and billing.";

  return (
    <div className="space-y-2" data-testid="signup-phone-field-group">
      <div className="flex items-center justify-between gap-3">
        <Label htmlFor="phone-number">{phoneLabel}</Label>
        <span className="text-xs text-muted-foreground" data-testid="signup-phone-helper-text">{helperText}</span>
      </div>
      <div className="grid gap-3 sm:grid-cols-[190px_minmax(0,1fr)]">
        <div className="space-y-2">
          <Label htmlFor="phone-country-select" className="text-xs text-muted-foreground">{countryLabel}</Label>
          <Select value={selectedCountry.iso2} onValueChange={onCountryChange}>
            <SelectTrigger id="phone-country-select" className="bg-background border-border focus:border-primary" data-testid="signup-phone-country-select-trigger">
              <span className="flex items-center gap-2">
                <span aria-hidden="true">{selectedCountry.flag}</span>
                <span>{selectedCountry.dialCode}</span>
              </span>
            </SelectTrigger>
            <SelectContent>
              {countries.map((country) => (
                <SelectItem key={country.iso2} value={country.iso2} data-testid={`signup-phone-country-option-${country.iso2.toLowerCase()}`}>
                  <span className="flex items-center gap-2">
                    <span aria-hidden="true">{country.flag}</span>
                    <span>{language === "es" ? country.nameEs : country.nameEn}</span>
                    <span className="text-muted-foreground">{country.dialCode}</span>
                  </span>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="phone-number" className="text-xs text-muted-foreground">{language === "es" ? "Número" : "Number"}</Label>
          <Input
            id="phone-number"
            type="tel"
            inputMode="numeric"
            placeholder={selectedCountry.placeholder}
            value={phoneNumber}
            onChange={(event) => onPhoneChange(event.target.value)}
            required
            maxLength={15}
            autoComplete="tel-national"
            className="bg-background border-border focus:border-primary"
            data-testid="signup-phone-number-input"
          />
        </div>
      </div>
    </div>
  );
};